import { Box } from "@chakra-ui/react";
import { SectionHead } from "@/components";
import { KNIT_PROGRAM_HEAD } from "@/content";
import { DatViewer } from "./knit/DatViewer";

export const KnittingProgram = () => (
  <Box as="section" id="program" maxW="maxw" mx="auto" px="pad" pb="sec">
    <SectionHead head={KNIT_PROGRAM_HEAD} />
    <DatViewer />
  </Box>
);
